/**
 * IonNextToolStatus — the running-tool chip of the Ion Next admin tab.
 *
 * Replaces the shared ToolStatusInline ("code_execution (22 / 23)") on this
 * tab only: a running code execution says what its code is for
 * (ionNextCodeStatus), any other call shows its localised status descriptor
 * ("Writing code…", "Searching the web…"), the tool name when there is none.
 * The seconds since the call started tick next to it, since a deck can take
 * a minute.
 */

import { useEffect, useState } from 'preact/hooks'
import { t } from '../../../i18n/index.js'
import { ionNextCodeStatus } from './ionNextCodeStatus.js'

export function ionNextToolLabel(call) {
  if (call.name === 'code_execution') {
    const derived = ionNextCodeStatus(call.input)
    if (derived) return `${derived.label}${derived.file ? ` (${derived.file})` : ''}…`
  }
  const sd = call.statusDescriptor
  return sd && sd.key ? t(sd.key, sd.params || {}) : call.name
}

/**
 * @param {object} props
 * @param {Array} props.toolCalls — message.toolCalls from chatStore
 */
export function IonNextToolStatus({ toolCalls = [] }) {
  const running = (toolCalls || []).filter((c) => c.status === 'running')
  const latest = running[running.length - 1]
  const [now, setNow] = useState(() => Date.now())

  const ticking = Boolean(latest)
  useEffect(() => {
    if (!ticking) return undefined
    setNow(Date.now())
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [ticking])

  if (!latest) return null
  const others = running.length - 1
  const elapsed =
    typeof latest.startedAt === 'number' ? Math.max(0, Math.floor((now - latest.startedAt) / 1000)) : null

  return (
    <div class="ion-tool-status" aria-live="polite">
      <span class="ion-tool-status__spinner" aria-hidden="true" />
      <span class="ion-tool-status__name">{ionNextToolLabel(latest)}</span>
      {elapsed !== null && <span class="ion-tool-status__progress">{elapsed}s</span>}
      {others > 0 && <span class="ion-tool-status__more">+{others}</span>}
    </div>
  )
}
